// extracted by mini-css-extract-plugin
export var Button = "BPTLButton-module--Button--6dce0";
export var Checkbox = "BPTLButton-module--Checkbox--b0093";
export var CloseButton = "BPTLButton-module--CloseButton--ab49e";
export var Content = "BPTLButton-module--Content--4c3cd";
export var HeadingText = "BPTLButton-module--HeadingText--39a37";
export var Img = "BPTLButton-module--Img--8b81e";
export var InputWrapper = "BPTLButton-module--InputWrapper--f0d28";
export var InputWrapperColumn = "BPTLButton-module--InputWrapperColumn--e2127";
export var Pink = "BPTLButton-module--Pink--3dd71";
export var Popup = "BPTLButton-module--Popup--7c0b1";
export var RTForm = "BPTLButton-module--RTForm--9f79e";
export var RTVotingBox = "BPTLButton-module--RTVotingBox--74355";
export var ReturnToContent = "BPTLButton-module--ReturnToContent--522d7";
export var SideImage = "BPTLButton-module--SideImage--39169";
export var TextBlock = "BPTLButton-module--TextBlock--fd140";
export var Underlay = "BPTLButton-module--Underlay--02486";